// extracted by mini-css-extract-plugin
module.exports = {"logo":"DevestInvestor_logo__5L3RM","logo_container":"DevestInvestor_logo_container__pd2Sz"};